import { DynamicFormData, DynamicFormFieldValidation } from '@app/shared/models/dynamic-form.model';
import {
    FormControl,
    FormControlOptions,
    FormGroup,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import {
    DYNAMIC_FORM_FIELD_TYPE,
    DYNAMIC_FORM_FIELD_VALIDATOR_TYPE,
} from '@app/shared/enum/dynamic-form';
import { Injectable } from '@angular/core';

@Injectable()
export class DynamicFormService {
    private formGroup: FormGroup;

    createFormGroup(formData: DynamicFormData): FormGroup {
        const group: any = {};

        formData.fields.forEach((field) => {
            const validators = this.getValidators(field.validation);
            const defaultValue = field.type === DYNAMIC_FORM_FIELD_TYPE.NUMBER ? 0 : '';

            group[field.key] = new FormControl(
                {
                    value: field.value || defaultValue,
                    disabled: field.disabled,
                },
                validators
            );
        });

        this.formGroup = new FormGroup(group);
        return this.formGroup;
    }

    getFormValue(): unknown {
        return this.formGroup.getRawValue();
    }

    setFormValue(data: unknown): void {
        this.formGroup.setValue(data);
    }

    private getValidators(
        fieldValidators: DynamicFormFieldValidation[]
    ): ValidatorFn | ValidatorFn[] | FormControlOptions | null {
        const validators: ValidatorFn[] = [];

        fieldValidators.forEach((validator) => {
            if (validator.type === DYNAMIC_FORM_FIELD_VALIDATOR_TYPE.REQUIRED) {
                validators.push(Validators.required);
            }

            if (validator.type === DYNAMIC_FORM_FIELD_VALIDATOR_TYPE.MIN) {
                validators.push(Validators.min(validator.compareValue));
            }

            if (validator.type === DYNAMIC_FORM_FIELD_VALIDATOR_TYPE.MAX) {
                validators.push(Validators.max(validator.compareValue));
            }

            if (validator.type === DYNAMIC_FORM_FIELD_VALIDATOR_TYPE.CUSTOM) {
                validators.push(validator.validationFn);
            }
        });

        return validators;
    }
}
